// Single source of truth for plan display labels and per-plan quotas, consumed
// by both the API (storage-quota enforcement, tenant status) and the admin
// portal (quotas panel, client overview). `null` means unlimited.

export const PLAN_LABELS: Record<string, string> = {
  launch: "Starter",
  growth: "Growth",
  bespoke: "Pro",
};

export interface PlanQuota {
  users: number | null;
  storageGb: number | null;
}

export const PLAN_QUOTAS: Record<string, PlanQuota> = {
  launch: { users: 2, storageGb: 10 },
  growth: { users: 10, storageGb: 25 },
  bespoke: { users: null, storageGb: 100 },
};

/** A plan's storage quota in GB, or null when the plan has none defined. */
export function planStorageGb(plan: string): number | null {
  return PLAN_QUOTAS[plan]?.storageGb ?? null;
}
